import axios from 'axios'

// 配置默认的host,假如你的API host是：http://api.htmlx.club
// axios.defaults.baseURL = 'http://api.htmlx.club' 
const forbidList = ["captchaImage", "login"]
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
　　// 在发送请求之前做些什么
    if(!config.url.includes(forbidList[0]) && !config.url.includes(forbidList[1])) {
        config.headers.Authorization = localStorage.getItem('tokens')
    }
　　return config
}, function (error) {
　　// 对请求错误做些什么
return Promise.reject(error)
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
　　// 对响应数据做点什么
    if (response.data.code == '401') {
        // localStorage.setItem('tokens', '')
        // localStorage.setItem('studentName', '')
        // localStorage.setItem('userId', '')
        // window.location.href = window.location.protocol + '//' + window.location.host + '/mobile/index.html#/login'
    }
　　return response
}, function (error) {
　　// 对响应错误做点什么
　　return Promise.reject(error)
});


//////////////////
// WEBPACK FOOTER
// ./config/request.js
// module id = CxTG
// module chunks = 11